import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  padding-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
    padding-bottom: ${em(40)};
  }
`
